import React from 'react'
// import { useConfig, useCurrentDoc } from 'docz'
// fix error: 'useConfig' is defined but never used and 'useCurrentDoc' is defined but never used
// import OGHeader from "../../../components/header"

// const [colorMode, setColorMode] = useColorMode()

//   const toggleColorMode = () => {
//     setColorMode(colorMode === 'light' ? 'dark' : 'light')
//   }

// Unexpected empty object pattern
export const Header = () => {
  return (
    <div />
  )
}
